import React from 'react';
import Stories from '../components/SNS/Story/Stories';
import LandingContent from '../components/Landing/LandingContent';

function HomePage() {
  return (
    <>
      {/* <Stories /> */}
      <LandingContent />
    </>
  );
}

export default HomePage;
